<template>
  <el-dialog
    v-model="visible"
    width="520px"
    append-to-body
    destroy-on-close
    class="appointment-modal"
    :title="'Выполнить приём'"
    @close="onClose"
  >
    <div class="appointment-modal-body">
    <!-- Блок заголовка с инфой о приёме -->
    <div class="appointment-header-visual">
      <div class="header-row">
        <div class="header-item">
          <el-icon><Calendar /></el-icon>
          <span>{{ formatDate(appointment.date) }}</span>
          <span style="color: var(--ui-color-text-soft);">({{ formattedDate(appointment.date) }}
            <span class="date-weekday" :class="{ weekend: isWeekend }">
              {{ weekdayLabel }}
            </span>)
          </span>
        </div>
        <div class="header-item">
          <el-icon><Clock /></el-icon>
          <span>{{ appointment.start_time }} – {{ appointment.end_time }}</span>
        </div>
      </div>
      <div class="header-row">
        <div class="header-item">
          <el-icon><UserFilled /></el-icon>
          <span>{{ appointment.user_name }}</span>
        </div>
        <div class="header-item">
          <el-icon><Folder /></el-icon>
          <span>{{ appointment.room_name }}</span>
        </div>
      </div>
    </div>

    <!-- Форма -->
    <el-form
      :model="fullForm"
      :rules="rules"
      ref="formRef"
      label-width="120px"
      label-position="top"
      style="margin-top: 16px;"
      class="appointment-form"
    >

      <!-- Услуги (мультивыбор) -->
      <el-form-item label="Услуги" prop="services" class="form-item" >
        <ServiceMultiSelect
          v-model="form.services"
          :services="services"
          :remote="true"
          :city-id="appointment?.city_id"
        />
      </el-form-item>

      <!-- Кастомные поля для закрытия -->
      <template v-for="(group, index) in groupedCloseFields" :key="index">
        <el-row v-if="group.length === 2 && group[0].type === 'number' && group[1].type === 'number'" :gutter="16" style="margin-bottom: 20px;">
          <el-col :span="12">
            <el-form-item
              :label="group[0].label"
              :prop="'custom_' + group[0].id"
              :required="!!group[0].required"
              class="form-item"
            >
              <template v-if="group[0].type === 'date'">
                <el-date-picker
                  v-model="customFieldValues[group[0].id]"
                  type="date"
                  placeholder="Выберите дату"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                />
              </template>
              <template v-else-if="group[0].type === 'datetime'">
                <el-date-picker
                  v-model="customFieldValues[group[0].id]"
                  type="datetime"
                  placeholder="Выберите дату и время"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%;"
                />
              </template>
              <template v-else-if="group[0].type === 'select'">
                <el-select
                  v-model="customFieldValues[group[0].id]"
                  placeholder="Выберите..."
                  filterable
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="option in group[0].options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  />
                </el-select>
              </template>
              <template v-else-if="group[0].type === 'multiselect'">
                <el-select
                  v-model="customFieldValues[group[0].id]"
                  placeholder="Выберите..."
                  multiple
                  filterable
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="option in group[0].options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  />
                </el-select>
              </template>
              <template v-else-if="group[0].type === 'radio'">
                <el-radio-group v-model="customFieldValues[group[0].id]">
                  <el-radio
                    v-for="option in group[0].options"
                    :key="option.value"
                    :label="option.value"
                  >
                    {{ option.label }}
                  </el-radio>
                </el-radio-group>
              </template>
              <template v-else>
                <component
                  :is="getFieldComponent(group[0])"
                  v-model="customFieldValues[group[0].id]"
                  v-bind="getFieldProps(group[0])"
                  style="width: 100%;"
                />
              </template>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="group[1].label"
              :prop="'custom_' + group[1].id"
              :required="!!group[1].required"
              class="form-item"
            >
              <template v-if="group[1].type === 'date'">
                <el-date-picker
                  v-model="customFieldValues[group[1].id]"
                  type="date"
                  placeholder="Выберите дату"
                  value-format="yyyy-MM-dd"
                  style="width: 100%;"
                />
              </template>
              <template v-else-if="group[1].type === 'datetime'">
                <el-date-picker
                  v-model="customFieldValues[group[1].id]"
                  type="datetime"
                  placeholder="Выберите дату и время"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 100%;"
                />
              </template>
              <template v-else-if="group[1].type === 'select'">
                <el-select
                  v-model="customFieldValues[group[1].id]"
                  placeholder="Выберите..."
                  filterable
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="option in group[1].options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  />
                </el-select>
              </template>
              <template v-else-if="group[1].type === 'multiselect'">
                <el-select
                  v-model="customFieldValues[group[1].id]"
                  placeholder="Выберите..."
                  multiple
                  filterable
                  clearable
                  style="width: 100%;"
                >
                  <el-option
                    v-for="option in group[1].options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value"
                  />
                </el-select>
              </template>
              <template v-else-if="group[1].type === 'radio'">
                <el-radio-group v-model="customFieldValues[group[1].id]">
                  <el-radio
                    v-for="option in group[1].options"
                    :key="option.value"
                    :label="option.value"
                  >
                    {{ option.label }}
                  </el-radio>
                </el-radio-group>
              </template>
              <template v-else>
                <component
                  :is="getFieldComponent(group[1])"
                  v-model="customFieldValues[group[1].id]"
                  v-bind="getFieldProps(group[1])"
                  style="width: 100%;"
                />
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-else>
          <el-form-item
            v-for="field in group"
            :key="field.id"
            :label="field.label"
            :prop="`custom_${field.id}`"
            :required="!!field.required"
            class="form-item"
          >
            <template v-if="field.type === 'date'">
              <el-date-picker
                v-model="customFieldValues[field.id]"
                type="date"
                placeholder="Выберите дату"
                value-format="yyyy-MM-dd"
                style="width: 100%;"
              />
            </template>
            <template v-else-if="field.type === 'datetime'">
              <el-date-picker
                v-model="customFieldValues[field.id]"
                type="datetime"
                placeholder="Выберите дату и время"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%;"
              />
            </template>
            <template v-else-if="field.type === 'select'">
              <el-select
                v-model="customFieldValues[field.id]"
                placeholder="Выберите..."
                filterable
                clearable
                style="width: 100%;"
              >
                <el-option
                  v-for="option in field.options"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </template>
            <template v-else-if="field.type === 'multiselect'">
              <el-select
                v-model="customFieldValues[field.id]"
                placeholder="Выберите..."
                multiple
                filterable
                clearable
                style="width: 100%;"
              >
                <el-option
                  v-for="option in field.options"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </el-select>
            </template>
            <template v-else-if="field.type === 'radio'">
              <el-radio-group v-model="customFieldValues[field.id]">
                <el-radio
                  v-for="option in field.options"
                  :key="option.value"
                  :label="option.value"
                >
                  {{ option.label }}
                </el-radio>
              </el-radio-group>
            </template>
            <template v-else>
              <component
                :is="getFieldComponent(field)"
                v-model="customFieldValues[field.id]"
                v-bind="getFieldProps(field)"
                style="width: 100%;"
              />
            </template>
          </el-form-item>
        </template>
      </template>

      <el-row :gutter="16" style="margin-bottom: 20px;">
        <el-col :span="12">
          <el-form-item label="Длительность" prop="duration" class="form-item">
            <el-input-number v-model="form.duration" :min="0" :step="15" style="width: 100%;" />
            <template #extra>
              <span style="margin-left: 8px;">мин.</span>
            </template>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Сумма" prop="total_sum" class="form-item">
            <el-input-number
              class="payment-total-input"
              size="large"
              :controls="false"
              v-model.number="form.total_sum"
              :min="0"
              :step="50"
              :formatter="value => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')"
              :parser="value => parseInt(value.replace(/\s/g, ''))"
              style="width: 100%;"
            />
            <template #extra>
              <span style="margin-left: 8px;">₽</span>
            </template>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- Оплата -->
      <el-form-item label="Оплата">
        <el-radio-group v-model="form.payment_method">
          <el-radio label="cash">Наличные</el-radio>
          <el-radio label="cashless">Безнал</el-radio>
          <el-radio
            label="abonement"
            :disabled="balance < form.total_sum"
          >
            Абонемент (доступно {{ balance }}₽)
          </el-radio>
          <el-radio
            v-if="balance > 0 && balance < form.total_sum"
            label="mixed"
          >
            Смешанная
          </el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- Сумма по источникам оплаты (только для смешанной оплаты) -->
      <el-form-item v-if="form.payment_method === 'mixed'" label="Сумма по источникам оплаты">
        <el-row :gutter="10" style="width: 100%;">
          <el-col :span="8">
            <el-input-number
              v-model.number="form.abonement_part"
              :min="0"
              :max="availableAbonementPart"
              :step="50"
              placeholder="Абонемент"
              style="width: 100%;"
            />
            <div class="input-label">Абонемент</div>
          </el-col>
          <el-col :span="8">
            <el-input-number
              v-model.number="form.cash_part"
              :min="0"
              :max="availableCashPart"
              :step="50"
              placeholder="Наличные"
              style="width: 100%;"
            />
            <div class="input-label">Наличные</div>
          </el-col>
          <el-col :span="8">
            <el-input-number
              v-model.number="form.cashless_part"
              :min="0"
              :max="availableCashlessPart"
              :step="50"
              placeholder="Безнал"
              style="width: 100%;"
            />
            <div class="input-label">Безнал</div>
          </el-col>
        </el-row>
      </el-form-item>

      <!-- Комментарий -->
      <el-form-item label="Комментарий" prop="comment" class="form-item">
        <el-input
          type="textarea"
          v-model="form.comment"
          placeholder="Комментарий"
          :autosize="{ minRows: 3, maxRows: 5 }"
        />
      </el-form-item>
    </el-form>

    </div>
    <template #footer>
      <el-button @click="onClose" class="btn-cancel">Отмена</el-button>
      <el-button
        type="primary"
        class="btn-save"
        @click="onSave"
        :loading="loading"
        :disabled="form.payment_method === 'mixed' && computedMixedTotal !== form.total_sum"
      >Выполнить</el-button>
    </template>
  </el-dialog>
</template>

<script>
import {
  Calendar,
  Clock,
  Folder,
  UserFilled,
} from '@element-plus/icons-vue'
import ServiceMultiSelect from '@/components/util/calendar/ServiceMultiSelect.vue'
import { mapActions, mapState } from 'vuex'
import { ElMessage } from 'element-plus'

export default {
  name: 'AppointmentCompleteModal',
  components: { ServiceMultiSelect, Calendar, Clock, Folder, UserFilled },
  props: {
    appointment: { type: Object, required: true },
    date: { type: String, required: false }
  },
  data() {
    return {
      visible: true,
      loading: false,
      form: {},
      customFieldValues: {},
      durationEdited: false,
      initialized: false,
    }
  },
  computed: {
    fullForm() {
      // Объединяет this.form и все кастомные поля в виде custom_{id}
      const result = { ...this.form }
      for (const [id, value] of Object.entries(this.customFieldValues)) {
        result[`custom_${id}`] = value
      }
      return result
    },
    ...mapState('custom_fields', ['fields']),
    ...mapState('services', ['services']),
    ...mapState('clients', ['balance']),
    closeFields() {
      // Показываем только кастомные поля для этапа закрытия
      return this.fields.filter(
        f => f.entity === 'appointment' && (f.stage === 'close' || f.stage === 'both')
      )
    },
    groupedCloseFields() {
      // Группируем только подряд идущие пары number-полей (строго по две).
      // Одиночные number — отдельной группой. Остальные поля — всегда отдельной группой.
      const fields = this.closeFields
      const groups = []
      let i = 0
      while (i < fields.length) {
        const current = fields[i]
        const next = fields[i + 1]
        if (
          current.type === 'number' &&
          next &&
          next.type === 'number'
        ) {
          groups.push([current, next])
          i += 2
        } else {
          groups.push([current])
          i += 1
        }
      }
      // Если всего два поля и оба number — обязательно сделать их парой (даже если не подряд, но по условию они подряд)
      if (
        fields.length === 2 &&
        fields[0].type === 'number' &&
        fields[1].type === 'number'
      ) {
        return [[fields[0], fields[1]]]
      }
      return groups
    },
    rules() {
      const rules = {
        services: [{ required: true, message: 'Укажите услуги', trigger: 'change' }],
        total_sum: [{ required: true, type: 'number', message: 'Укажите сумму', trigger: 'change' }]
      }
      for (const field of this.closeFields) {
        if (field.required) {
          rules['custom_' + field.id] = [
            { required: true, message: 'Обязательное поле', trigger: 'change' }
          ]
        }
      }
      return rules
    },
    weekdayLabel() {
      if (!this.appointment?.date) return ''
      const d = new Date(this.appointment.date)
      const weekdays = ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб']
      return weekdays[d.getDay()]
    },
    isWeekend() {
      if (!this.appointment?.date) return false
      const d = new Date(this.appointment.date)
      return d.getDay() === 0 || d.getDay() === 6
    },
    totalDuration() {
      if (this.form && this.form.services && this.form.services.length) {
        return this.form.services.reduce((sum, s) => sum + (s.duration || 0), 0)
      }
      return 0
    },
    computedMixedTotal() {
      return (this.form.abonement_part || 0) + (this.form.cash_part || 0) + (this.form.cashless_part || 0)
    },
    availableCashlessPart() {
      const total = this.form.total_sum || 0
      const abonement = this.form.abonement_part || 0
      const cash = this.form.cash_part || 0
      return Math.max(0, total - abonement - cash)
    },
    availableCashPart() {
      const total = this.form.total_sum || 0
      const abonement = this.form.abonement_part || 0
      const cashless = this.form.cashless_part || 0
      return Math.max(0, total - abonement - cashless)
    },
    availableAbonementPart() {
      const total = this.form.total_sum || 0
      const cash = this.form.cash_part || 0
      const cashless = this.form.cashless_part || 0
      const remaining = total - cash - cashless
      return Math.min(this.balance, remaining)
    }
  },
  // Логика инициализации формы теперь в watch: appointment
  watch: {
    appointment: {
      immediate: true,
      handler(val) {
        // Копируем appointment в form (глубоко)
        this.form = JSON.parse(JSON.stringify(val || {}))
        // Кастомные значения если есть
        this.customFieldValues = { ...(val?.custom_fields || {}) }
        this.form.payment_method = 'cash'
        this.initialized = false
        this.durationEdited = false
        this.$nextTick(() => {
          // duration_time приоритетнее duration
          if (this.form.duration_time) {
            this.form.duration = this.form.duration_time
          } else if (!this.form.duration && !this.form.duration_time) {
            this.form.duration = this.totalDuration
          }
          this.initialized = true
        })
      }
    },
    'form.services': {
      handler() {
        if (this.initialized) {
          this.form.duration = this.totalDuration
        }
      }
    },
    'form.duration'() {
      this.durationEdited = true
    },
    'form.abonement_part'(val) {
      const total = this.form.total_sum || 0
      const balance = this.balance || 0
      const cash = this.form.cash_part || 0
      const cashless = this.form.cashless_part || 0

      // остаток после двух других частей
      const remaining = total - cash - cashless
      const maxAllowed = Math.min(balance, remaining)

      // 1. Строго ограничить сумму абонементной части
      if (val > maxAllowed) {
        this.form.abonement_part = maxAllowed
        return
      }
      if (val < 0) {
        this.form.abonement_part = 0
        return
      }

      // 2. Если сумма переполнена — скорректировать вниз оставшиеся части
      const over = val + cash + cashless - total
      if (over > 0) {
        // Сначала уменьшаем безнал, потом наличные
        if (this.form.cashless_part && this.form.cashless_part >= over) {
          this.form.cashless_part -= over
        } else if (this.form.cash_part && this.form.cash_part >= over) {
          this.form.cash_part -= over
        } else {
          // если обе части меньше — обнуляем обе
          this.form.cashless_part = 0
          this.form.cash_part = 0
        }
      }
    }
  },
  mounted() {
    this.getBalance(this.appointment.client_id);
  },
  methods: {
    ...mapActions('clients', ['getBalance']),
    getFieldComponent(field) {
      // Выбери нужный компонент для рендера по типу поля
      if (field.type === 'number') return 'el-input-number'
      if (field.type === 'checkbox') return 'el-checkbox'
      if (field.type === 'textarea') return 'el-input'
      if (field.type === 'select' || field.type === 'radio')
        return 'el-select'
      // По умолчанию
      return 'el-input'
    },
    getFieldProps(field) {
      // Верни нужные props в зависимости от типа поля
      if (field.type === 'number') {
        return { min: field.min ?? 0, max: field.max ?? 999999, step: 1 }
      }
      if (field.type === 'select' || field.type === 'radio') {
        return {
          placeholder: 'Выберите...',
          style: 'width: 100%',
          multiple: false,
          filterable: true,
          clearable: true,
          options: field.options || []
        }
      }
      if (field.type === 'textarea') {
        return { type: 'textarea', autosize: { minRows: 2, maxRows: 4 } }
      }
      return {}
    },
    formatDate(date) {
      if (!date) return ''
      const parts = date.split('-')
      if (parts.length !== 3) return date
      return `${parts[2]}.${parts[1]}.${parts[0]}`
    },
    formattedDate(date) {
      if (!date) return ''
      const months = [
        'Января', 'Февраля', 'Марта', 'Апреля', 'Мая', 'Июня',
        'Июля', 'Августа', 'Сентября', 'Октября', 'Ноября', 'Декабря'
      ]
      const [, month, day] = date.split('-')
      return `${day} ${months[parseInt(month, 10) - 1]}`
    },
    onSave() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid){
          ElMessage.error('Обязательное поля не заполнены')
          return;
        }
        this.loading = true
        try {
          // Собираем custom_fields
          const custom_fields = { ...this.customFieldValues }
          const data = {
            ...this.appointment,
            ...this.form,
            custom_fields,
            status: 'done'
          }

          // Собираем массив transactions
          data.transactions = []
          if (this.form.payment_method === 'cash' || this.form.payment_method === 'cashless') {
            data.transactions.push({
              type: 'payment',
              method: this.form.payment_method,
              amount: this.form.total_sum
            })
          }
          if (this.form.payment_method === 'abonement') {
            data.transactions.push({
              type: 'abonement_spend',
              amount: this.form.total_sum
            })
          }
          if (this.form.payment_method === 'mixed') {
            const abonementPart = this.form.abonement_part || 0
            const cashPart = this.form.cash_part || 0
            const cashlessPart = this.form.cashless_part || 0

            if (abonementPart > 0) {
              data.transactions.push({ type: 'abonement_spend', amount: abonementPart })
            }
            if (cashPart > 0) {
              data.transactions.push({ type: 'payment', method: 'cash', amount: cashPart })
            }
            if (cashlessPart > 0) {
              data.transactions.push({ type: 'payment', method: 'cashless', amount: cashlessPart })
            }
            data.abonement_part = abonementPart
            data.cash_part = cashPart
            data.cashless_part = cashlessPart
          }

          // Логика для смешанного способа оплаты (валидация)
          if (this.form.payment_method === 'mixed') {
            const abonementPart = this.form.abonement_part || 0
            const cashPart = this.form.cash_part || 0
            const cashlessPart = this.form.cashless_part || 0
            const total = abonementPart + cashPart + cashlessPart
            if (abonementPart > this.balance) {
              this.$message.error('Списываемая сумма с абонемента превышает доступный баланс')
              this.loading = false
              return
            }
            if (total !== this.form.total_sum) {
              this.$message.error(`Сумма по источникам (${total}) не совпадает с общей суммой приёма (${this.form.total_sum})`)
              this.loading = false
              return
            }
          }

          console.debug(data);

          // Здесь вызов экшена или API (пример):
          await this.$store.dispatch('appointments/closeAppointment', data)
          this.$emit('close')
        } catch (e) {
          this.$message.error('Ошибка при закрытии приёма')
        }
        this.loading = false
      })
    },
    onClose() {
      this.visible = false
      this.$emit('close')
    }
  }
}
</script>
<style>
.payment-total-input.el-input-number .el-input__inner {
  font-size: 22px;
}
</style>
<style scoped>
.appointment-modal-body {
  background: linear-gradient(rgba(0, 108, 254, 0.22), rgba(0, 108, 254, 0.22)), linear-gradient(151deg, #15264e 0%, #030b1b 100%);
  border-radius: 14px;
  padding: 26px 28px 24px;
}

.appointment-header-visual {
  margin-bottom: 22px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.header-row {
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}

.header-item {
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #dce8ff;
  gap: 10px;
  line-height: 1.25;
}

.header-item :deep(.el-icon) {
  color: #031230 !important;
}

.header-item :deep(.el-icon svg) {
  color: #031230 !important;
  fill: #031230 !important;
  stroke: #031230 !important;
}

.date-weekday {
  font-size: 14px;
  margin-left: 4px;
  color: #7ab6ff;
  font-weight: 700;
}

.date-weekday.weekend {
  color: #ff8f8f;
}

.appointment-form {
  color: #dce8ff;
}

.form-item {
  margin-bottom: 20px;
}

.appointment-form :deep(.el-form-item__label) {
  font-weight: 600;
  font-size: 14px;
  color: #dce8ff;
  padding-bottom: 6px;
}

.appointment-form :deep(.el-input),
.appointment-form :deep(.el-input-number),
.appointment-form :deep(.el-select),
.appointment-form :deep(.el-date-picker),
.appointment-form :deep(.el-textarea),
.appointment-form :deep(.el-radio-group) {
  width: 100%;
  color: #eaf3ff;
}

.appointment-form :deep(.el-input__wrapper),
.appointment-form :deep(.el-textarea__inner),
.appointment-form :deep(.el-select__wrapper),
.appointment-form :deep(.el-input-number .el-input__wrapper),
.appointment-form :deep(.el-date-editor.el-input__wrapper) {
  background: linear-gradient(180deg, #4b6fba 0%, #385aa1 100%);
  box-shadow: 0 0 0 1px #496fb7 inset !important;
  color: #eaf3ff;
  border-radius: 12px;
}

.appointment-form :deep(.el-input__inner),
.appointment-form :deep(.el-input-number__input),
.appointment-form :deep(.el-select__input),
.appointment-form :deep(.el-date-editor--date),
.appointment-form :deep(.el-date-editor--datetime),
.appointment-form :deep(.el-textarea__inner) {
  font-size: 14px;
  color: #eaf3ff;
}

.appointment-form :deep(.el-input__inner::placeholder),
.appointment-form :deep(.el-textarea__inner::placeholder) {
  color: #8ac1ff;
}

.appointment-form :deep(.el-radio-group) {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.appointment-form :deep(.el-radio) {
  font-size: 14px;
  color: #dce8ff;
}

.appointment-form :deep(.el-textarea__inner) {
  font-size: 14px;
  color: #eaf3ff;
  resize: vertical;
  min-height: 60px;
  max-height: 120px;
}

.appointment-form :deep(.el-radio__label) {
  color: #dce8ff;
}

.appointment-form :deep(.el-radio__input.is-checked .el-radio__inner) {
  background: #58c8ff;
  border-color: #58c8ff;
}

.appointment-form :deep(.el-radio__input.is-checked + .el-radio__label) {
  color: #eef6ff;
}

.appointment-form :deep(.el-input-number__decrease),
.appointment-form :deep(.el-input-number__increase) {
  background: linear-gradient(180deg, #25488b 0%, #17366d 100%);
  color: #58c8ff;
  border-color: transparent;
}

:global(.appointment-modal) {
  background: transparent !important;
  border-radius: 14px;
  box-shadow: none !important;
  border: none !important;
  margin-top: 7vh !important;
}

:global(.appointment-modal .el-dialog__header) {
  background: transparent !important;
  padding: 0;
  margin: 0;
}

:global(.appointment-modal .el-dialog__body) {
  background: transparent !important;
  padding: 0;
}

:global(.appointment-modal .el-dialog__footer) {
  background: transparent !important;
  padding: 0;
}

:global(.appointment-modal .el-dialog__headerbtn .el-dialog__close) {
  color: #031230;
  font-size: 24px;
}

.appointment-modal-body :deep(.el-icon),
.appointment-modal-body :deep(.el-icon svg),
.appointment-modal-body :deep(.el-icon svg path) {
  color: #031230 !important;
  fill: #031230 !important;
  stroke: #031230 !important;
}

.btn-cancel,
.btn-save {
  min-width: 170px;
  height: 56px;
  border-radius: 14px;
  font-size: 18px;
  border: none;
}

.btn-cancel {
  background: var(--appointment-secondary);
  color: var(--appointment-secondary-text);
  box-shadow: 0 0 0 1px rgba(118, 159, 232, 0.25) inset;
}

.btn-save {
  background: var(--appointment-primary) !important;
  color: var(--appointment-primary-text) !important;
}

:global(.appointment-modal .el-button),
:global(.appointment-modal .el-link),
:global(.appointment-modal .el-input__wrapper),
:global(.appointment-modal .el-textarea__inner),
:global(.appointment-modal .el-select__wrapper),
:global(.appointment-modal .el-input-number .el-input__wrapper) {
  transition: background-color .18s ease, color .18s ease, border-color .18s ease, box-shadow .18s ease, filter .18s ease;
}

:global(.appointment-modal .el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(.el-button--danger):hover),
:global(.appointment-modal .el-button:not(.el-button--primary):not(.el-button--success):not(.el-button--warning):not(.el-button--danger):focus-visible),
:global(.appointment-modal .el-button.is-text:hover),
:global(.appointment-modal .el-button.is-text:focus-visible) {
  background: linear-gradient(rgb(16 53 117 / 52%), rgb(16 53 117 / 52%)) !important;
  border-color: #3f6fb8 !important;
  color: #dce8ff !important;
  box-shadow: 0 0 0 1px rgb(63 111 184 / 55%) inset !important;
}

:global(.appointment-modal .el-button.el-button--primary:hover),
:global(.appointment-modal .el-button.el-button--success:hover),
:global(.appointment-modal .el-button.el-button--warning:hover),
:global(.appointment-modal .el-button.el-button--danger:hover),
:global(.appointment-modal .el-button.el-button--primary:focus-visible),
:global(.appointment-modal .el-button.el-button--success:focus-visible),
:global(.appointment-modal .el-button.el-button--warning:focus-visible),
:global(.appointment-modal .el-button.el-button--danger:focus-visible) {
  filter: brightness(.95);
}

:global(.appointment-modal .el-button:active) {
  filter: brightness(.9);
}

:global(.appointment-modal .el-input__wrapper:hover),
:global(.appointment-modal .el-select__wrapper:hover),
:global(.appointment-modal .el-input-number .el-input__wrapper:hover),
:global(.appointment-modal .el-textarea__inner:hover),
:global(.appointment-modal .el-input__wrapper.is-focus),
:global(.appointment-modal .el-select__wrapper.is-focused),
:global(.appointment-modal .el-input-number .el-input__wrapper.is-focus) {
  box-shadow: 0 0 0 1px #5a82ca inset !important;
  background: linear-gradient(180deg, #4f72bb 0%, #3c5fa7 100%) !important;
}

:global(.appointment-modal .el-link:hover),
:global(.appointment-modal .el-link:focus-visible) {
  color: #57c7ff !important;
}

:global(.appointment-modal .el-table__body tr:hover > td.el-table__cell) {
  background: rgba(24, 53, 104, 0.55) !important;
}
</style>
